import TaskRecords from '../views/tasks/records.vue'
export default [
  {
    path: '/records',
    name: "records",
    component: TaskRecords
  }
]